import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "viet-qr-payment d-inline-flex flex-column align-items-start gap-2" }
const _hoisted_2 = {
  key: 1,
  class: "d-flex flex-wrap align-items-start gap-2"
}
const _hoisted_3 = { class: "text-secondary text-capitalize-first" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hideQr && _ctx.showVueQrcode)
      ? (_openBlock(), _createBlock(_component_vue_qrcode, {
          key: 0,
          value: _ctx.payload,
          tag: "svg",
          class: "viet-qr-payment__qr",
          style: {"width":"100%","border-radius":"10px"},
          options: { width: '200px' }
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_ctx.showVueQrcode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_copy_button, {
            value: _ctx.payload,
            class: "ms-1 d-flex"
          }, {
            default: _withCtx(() => [
              _createElementVNode("small", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.raw_field.qrString')), 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]))
      : (_ctx.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _ctx.imageUrl,
            alt: "",
            class: "viet-qr-payment__img"
          }, null, 8, _hoisted_4))
        : (_ctx.fallbackRequisites)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.fallbackRequisites), 1))
          : _createCommentVNode("", true)
  ]))
}